/*!
 * CardView - Classe parente pour les vues basées sur des fiches / cartes / icônes
 */

import BaseView from './BaseView';

export default class CardView extends BaseView {
    constructor(plugin, name) {
        super(plugin, name);
    }

    /**
     * Helper pour extraire et formater les sous-champs de données (infos).
     * @param {Object} data
     * @param {Array} fields
     * @returns {Array}
     */
    buildFieldsSubtext(data, fields) {
        const myself = this.plugin;
        const codeSubtext = [];
        if (data && fields && fields.length) {
            $.each(fields, (indexView, view) => {
                const rawVal = (data.data && data.data[view] !== undefined) ? data.data[view] : data[view];
                if (rawVal !== undefined && rawVal !== null && rawVal != data.label) {
                    codeSubtext.push(myself.renderSubdata(rawVal, null, null, data));
                }
            });
        }
        return codeSubtext;
    }
}
